/**
 * Enum para Abas de detalhes de Processo.
 *
 * @readonly
 * @constant
 * @enum {Object.<string, Object>}
 */

export const ABAS_DETALHES_PROCESSO = {
    PROCESSO: { id: 'P', label: 'Processo' },
    DECISAO: { id: 'D' },
    VOTO: { id: 'V' },
    PECAS: { id: 'E', label: 'Peças' }
};
